export default theme => ({
  root: {
    padding: "50px 0",
    backgroundColor: theme.palette.grey["200"]
  },
  title: {
    fontSize: theme.typography.pxToRem(30),
    fontWeight: theme.typography.fontWeightRegular,
    width: "40%",
    color: theme.palette.grey[600]
  }
});
